import { ucfirst } from '../strings';

export default {
  methods: {
    getPassengerType(typeValue) {
      switch (typeValue) {
        case "adult":
          return this.$tc('shared.adult', 1);
        case "child":
          return this.$tc('shared.child', 1);
        case "baby":
          return this.$tc('shared.baby', 1);
        default:
          return this.$tc('shared.passenger', 1);
      }
    },
    getPassengerLabel(typeValue, index) {
      return `${ucfirst(this.$tc('shared.passenger', 1))} #${index + 1}: ${this.getPassengerType(typeValue)}`;

      // const ordinal = [0, 2].includes(index) ? `${index + 1}<sup>er</sup>` : `${index + 1}<sup>o</sup>`;
      // const type = this.getPassengerType(typeValue);

      // return `${ordinal} ${this.$t('shared.passenger', 1)}: ${type}`;
    }
  }
};
